<template>
  <div>
    <b-modal :id="`bv-modal-campaign-status`" hide-footer>
      <template #modal-title>Campaign status</template>

      <div class="text-center">
        <b>{{campaign.name}}</b>
      </div>

      <div class="bg-white rounded">
        <div class="row">
          <div class="col">
            <label class="form-label">Status</label>
            <select
              class="form-control2"
              v-model="campaign.status"
              style="padding: 0.7rem 1.2rem">
              <option
                v-for="(status, index) in statuses"
                :key="index"
                :value="status">
                {{ status }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-secondary submit col"
            @click="hideModalChangeStatus">Cancel</button>
        </div>
        <div class="col">
          <button
            v-if="updating"
            type="button"
            class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>
          </button>
          <button
            v-else
            type="button"
            class="btn btn-danger submit col" @click="saveEmail">Change</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from "../bus";

export default {
  props: ['campaign'],

  data() {
    return {
      updating: false,
      loading: false,
      statuses: ['Active', 'Inactive'],
    };
  },

  created() {},

  methods: {
    hideModalChangeStatus() {
      this.$bvModal.hide(`bv-modal-campaign-status`);
    },

    successAlert(text) {
      Swal.fire({
        title: text,
        customClass: { title: "popup-title", icon: "custom-icon-size" },
        icon: "success",
        showConfirmButton: false,
        timer: 3000,
      });
    },

    saveEmail() {
      this.updating = true;

      axios
        .post(`/campaigns/update-status`, {
          campaign_id: this.campaign.id,
          status: this.campaign.status,
        })
        .then((response) => {
          if (response.data.success) {
            EventBus.$emit("campaign-status-updated");
            this.hideModalChangeStatus();
            this.successAlert(response.data.message);
          } else {
            this.sweetfire(response.data.message);
          }

          this.updating = false;
        });
    },

    successAlert(text) {
      Swal.fire({
        title: text,
        customClass: { title: "popup-title", icon: "custom-icon-size"},
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    hideModalChangeStatus() {
      this.$bvModal.hide(`bv-modal-campaign-status`);
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },
};
</script>

<style scoped>
.campaign_image {
  height: 3rem;
}
</style>